import * as Styled from "./style";
import { NewTag } from "~/components/blocks/layout/global-navi/common/new-tag";

type Props = {
  menuName: string;
  isNew: boolean;
  isHeading: boolean;
};

export const MenuNameWithNewTag = (props: Props) => {
  const { menuName, isNew, isHeading } = props;

  return (
    <span>
      <Styled.SpanText isHeading={isHeading}>{menuName}</Styled.SpanText>
      {isNew && <NewTag />}
    </span>
  );
};
